<template>
  <div id="tooltip" class="arrow_box" style="display:none;"></div>
</template>

<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity .5s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}

#tooltip {
  z-index: 1000;
  display:inline-block;
  color: #000;
  background:#F8F6CA;
  min-width: 100px;
  padding: 5px;
}
.arrow_box {
	position: relative;
	background: #F8F6CA;
  border: 4px solid #F8F6CA;
  border-radius: 10px;
  -webkit-border-radius: 10px;    /* Safari,Google Chrome用 */  
  -moz-border-radius: 10px;

}
.arrow_box:after, .arrow_box:before{
	top: 100%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
  pointer-events: none;
	border-color: rgba(10, 95, 143, 0);
	border-top-color: #F8F6CA;
	border-width: 12px;
	margin-left: -50px;
}
</style>

<script>
export default {
  name: "tooltip",
  props: {
  },
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    showTooltip(e, message) { 
      $('#tooltip-child').remove()
      $('#tooltip').append('<pre id="tooltip-child">' + message + '</pre>').css("display", "none").trigger("create");
      this.$nextTick(function() {      
        if(!e.srcElement || !e.srcElement.clientWidth) {
          return;
        }

        // 吹き出しの位置設定
        const targetCenterX = $(e.target).offset().left + ($(e.target).width() / 2)
        const left = targetCenterX - ($('#tooltip').width() / 2)
        $('#tooltip').css({'position':'absolute','top':$(e.target).offset().top - 10 -$("#tooltip").outerHeight(true),'left': left});

        // 矢印の位置設定
        $('#tooltip').append('<style>.arrow_box:before, .arrow_box:after{ right: 50% }</style>');
      })
      $('#tooltip').css("display", "inline-block")
    },
    close(){
      $('#tooltip-child').remove()
      $('#tooltip').css("display", "none")
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/assets/js/components/Tooltip.vue